import { degreeDaysKeyForInsect } from 'App/dashboards/_utils/pestValueTypeKeys'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { sortByKey } from 'utils/sortByKey'

export type TBlockInfo = {
  blockId: number
  blockName: string
}

export const getBlocksForProperty = ({
  properties,
  propertyId,
  insectId,
}: {
  properties: TFieldAssetStoreState['properties']
  propertyId: number | null
  insectId: number
}): TBlockInfo[] => {
  if (propertyId === null) return []

  const property = properties?.[propertyId]

  if (!property) return []

  const blocks = Object.values(property.blocks ?? {})
  const ddValueTypeKey = degreeDaysKeyForInsect(insectId)

  return blocks
    .filter((b) => b.valuesTimeseries?.some((vt) => vt === ddValueTypeKey) && !!b.name)
    .map((b): TBlockInfo => ({
      blockId: b.blockId,
      blockName: b.name as string,
    }))
    .sort(sortByKey('blockName'))
}
